export default "__VITE_ASSET__CI_VxgFJ__"